export default "/images/consultant-spotlight-invite-new-programs.png?8d40796afa125bbc708a99a51e0437ab";